import React from "react";

const TermsAndConditions = () => {
  return (
    <div className="terms-area space">
      <div className="container">
        <h4 className="mb-4">Terms and Conditions</h4>
        <p>
          Welcome to Gowrisankar Agencies. By accessing or using our website, you agree to comply with and be bound by the following terms and conditions.
        </p>

        <h6>1. Use of the Website</h6>
        <p>
          This website is intended for users seeking auto parts information and purchases. Unauthorized use or duplication of content is prohibited.
        </p>

        <h6>2. Product Availability</h6>
        <p>
          We make every effort to ensure products listed are available and prices are accurate. We reserve the right to modify or discontinue items without prior notice.
        </p>

        <h6>3. Payments</h6>
        <p>
          All transactions must be completed via approved payment methods. Orders will be processed only after successful payment.
        </p>

        <h6>4. Limitation of Liability</h6>
        <p>
          Gowrisankar Agencies is not responsible for any direct or indirect damages arising from the use or inability to use our website or services.
        </p>

        <h6>5. Changes to Terms</h6>
        <p>
          We reserve the right to update these terms at any time. Continued use of the website constitutes your agreement to the new terms.
        </p>

        <p className="mt-4">
          If you have questions, contact us at <a href="mailto:rajesh.katakam@gmail.com">rajesh.katakam@gmail.com</a>.
        </p>
      </div>
    </div>
  );
};

export default TermsAndConditions;
